import React from 'react'
import GoodsContent from './router'
import { getBEMCls } from '@/utils/classname'
import { Column, Expaned } from '@/components/layout/layout'

import './mall-shelf.scss'
import { RouteComponentProps, useHistory } from 'react-router'
import Iconfont from '@/components/iconfont/iconfont'
import { GOODS_GOODS_LIBRARY } from '../../goods-manage/goods-storage/router'

export const MALL_DARG_TYPE = 'mall-drag-type'

const Goods = (props: RouteComponentProps) => {
    const getCls = (el?: string, m?: string) => getBEMCls('sg-goods', el, m)

    const histroy = useHistory()

    return (
        <Column className={getCls()}>
            <div className={getCls('header')}>
                <div data-font-size-24 data-color-000>
                    商城货架
                </div>
                <div
                    className={getCls('tag')}
                    onClick={() => {
                        histroy.replace(GOODS_GOODS_LIBRARY)
                    }}
                >
                    <Iconfont
                        name="icon1shangpinkai-24"
                        size={20}
                        style={{
                            marginRight: '6px',
                        }}
                    />
                    商品库
                </div>
            </div>
            <Expaned className={getCls('content')}>
                <GoodsContent {...props} />
            </Expaned>
        </Column>
    )
}

export default Goods
